<div class="dispute-history">
    <app-header
        [title]="'support.dispute-history.header.title' | translate"
        [hasBackButton]="false"
        [hasSearchButton]="true"
        [searchInput]="filter"
        [searchPlaceholder]="'support.dispute-history.header.filter' | translate"
        (onSearch)="onSearch($event)"
    />
    <div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
        <div class="corpo-pagina">
            <div class="card card-default">
                <app-support-gridview [config]="config" [templates]="templatesArray" [hasLineClick]="true" (onLineClick)="openDetail($event)"></app-support-gridview>

                <ng-template #infoTemplate let-item>
                    <i-feather class="info-icon" name="info" tooltip="{{item.disputeReason}}"></i-feather>
                </ng-template>

                <ng-template #statusTemplate let-item>
                    <div class="pill-label" [ngClass]="item.statusClass" [tooltip]="item.rejectReason">
                        {{item.statusDescription}}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<app-dispute-detail #templateDisputeDetail />
